import { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import { supabase } from "utils/supabase";
import { useHistory } from "react-router-dom";
import { getDeviceId } from "utils/devices";
import { capitalizeWords } from "utils/text.js";
import enarmApexLogo from "assets/img/enarm-apex-logo.png";

export default function RevisarPagos() {
    const history = useHistory();
    const [loadingPlan, setLoadingPlan] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [trialUsed, setTrialUsed] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const checkBilling = async () => {
            const {
            data: { user },
            } = await supabase.auth.getUser();

            if (!user) {
            history.replace("/auth");
            return;
            }
            setUser(user);
            const { data: billing, error } = await supabase.rpc("get_billing_status");
            if (error) {
            setErrorMessage("No pudimos verificar tu suscripcion. Intenta de nuevo.");
            console.error(error);
            return;
            }

            if (billing?.has_pro_access) {
            history.replace("/admin/dashboard");
            return;
            }

            setTrialUsed(Boolean(billing?.trial_used_at));
        };

    checkBilling();
    }, [history]);

    const startCheckout = async (plan) => {
        setErrorMessage("");
        setLoadingPlan(plan);

        const { data, error } = await supabase.functions.invoke(
            "create-checkout-session",
            {
            body: {
                plan, // "monthly" | "yearly"
            },
            }
        );

        if (error) {
            setLoadingPlan(null);
            setErrorMessage("No pudimos iniciar el checkout. Intenta de nuevo.");
            console.error(error);
            return;
        }

        if (!data?.url) {
            setLoadingPlan(null);
            setErrorMessage("No recibimos una URL de pago valida. Intenta de nuevo.");
            return;
        }

        window.location.href = data.url;
    };

    const handleLogout = async () => {
        await supabase.rpc("end_device_session", {
            p_device_id: getDeviceId(),
        });
        await supabase.auth.signOut()
        history.push("/auth");
    }

    return (
        <>
            <div className="container mx-auto px-4 h-full">
                <div className="flex content-start items-start justify-center h-full">
                    <div className="w-full lg:w-5/12 px-4 -mt-20">
                        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
                            <div className="rounded-t mb-0 px-6 py-6">
                                <div className="text-center mb-3">
                                    <img
                                        src={enarmApexLogo}
                                        alt="ENARM Apex Logo"
                                        className="w-32 mx-auto"
                                        style={{ width: "20rem" }}
                                    />
                                    <br />
                                    <h6 className="text-blueGray-500 text-lg font-bold">
                                        Elige tu plan
                                    </h6>
                                    <p className="text-sm text-blueGray-500 mt-2">
                                        {capitalizeWords(user?.user_metadata?.full_name, true) || "Hola"}, activa tu acceso PRO para continuar con ENARM Apex.
                                    </p>
                                </div>
                            </div>
                            <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                                {errorMessage && (
                                    <Alert severity="error" className="mb-4">
                                        {errorMessage}
                                    </Alert>
                                )}

                                <div className="space-y-3">
                                    <button
                                        onClick={() => startCheckout("monthly")}
                                        disabled={loadingPlan !== null}
                                        className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none w-full ease-linear transition-all duration-150 disabled:opacity-60"
                                        type="button"
                                    >
                                        {loadingPlan === "monthly"
                                            ? "Redirigiendo..."
                                            : `${trialUsed ? "CONTRATA" : "PROBAR GRATIS"} mensual - $149/mes`}
                                    </button>

                                    <button
                                        onClick={() => startCheckout("yearly")}
                                        disabled={loadingPlan !== null}
                                        className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none w-full ease-linear transition-all duration-150 disabled:opacity-60"
                                        type="button"
                                    >
                                        {loadingPlan === "yearly"
                                            ? "Redirigiendo..."
                                            : `${trialUsed ? "CONTRATA" : "PROBAR GRATIS"} anual - $1490/año`}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-wrap mt-6 relative">
                            <div className="w-1/2">
                            </div>
                            <div className="w-1/2 text-right">
                                <button onClick={handleLogout} className="text-blueGray-200 bg-transparent border-0 p-0">
                                    <small>Cerrar sesión</small>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
